// import required libraries
import $ from "jquery";

// overwrite fonts so that they match our designs
// but skip Gravity Forms admin screens
if (!$("body").hasClass("gform-admin-screen")) {
	document.getElementsByTagName("html")[0].style.fontSize = "62.5%";
}
